import React, { useState } from "react";
import { Cell, Pie, PieChart, ResponsiveContainer, Sector } from "recharts";

export interface DonutSection {
  key: string;
  name: string;
  value: number;
  displayValues: string[];
  percentage: number;
  color: string | undefined;
}

interface Props {
  className?: string;
  style?: React.CSSProperties;
  data: DonutSection[]; // TODO: complete
  sizeInPx: number;
}

const DonutChart: React.FC<Props> = ({ data, sizeInPx, ...otherProps }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div style={{ width: sizeInPx, height: sizeInPx }} {...otherProps}>
      <ResponsiveContainer>
        <PieChart width={sizeInPx} height={sizeInPx}>
          <Pie
            activeIndex={activeIndex}
            activeShape={renderActiveShape}
            data={data}
            innerRadius={75}
            outerRadius={110}
            stroke="#fff"
            strokeWidth="3"
            dataKey="value"
            onMouseEnter={(data: DonutSection, index: number) => {
              setActiveIndex(index);
            }}
            isAnimationActive={false}
          >
            {data.map(({ key, color }, index) => (
              <Cell key={key} fill={color || colors[index % colors.length]} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default DonutChart;

//
// Utils
//

const colors = [
  "#29D391",
  "#38A2FF",
  "#E68B00",
  "#FF6666",
  "#BE73FF",
  "#595a9a",
  "#FFC769",
  "#9AE8C9"
];

const renderActiveShape = ({
  cx,
  cy,
  innerRadius,
  outerRadius,
  startAngle,
  endAngle,
  fill,
  payload
}: {
  cx: number;
  cy: number;
  innerRadius: number;
  outerRadius: number;
  startAngle: number;
  endAngle: number;
  fill: string;
  payload: DonutSection;
}) => {
  const topY = -10 - payload.displayValues.length * 10;
  const bottomY = -topY;

  return (
    <g>
      <text
        x={cx}
        y={cy + topY}
        dy={8}
        textAnchor="middle"
        fill="currentColor"
        fontSize="13"
        fontWeight="500"
      >
        {payload.name}
      </text>

      {payload.displayValues.map((value, index) => (
        <text
          key={index}
          x={cx}
          y={cy + topY + (index + 1) * 20}
          dy={8}
          textAnchor="middle"
          fill="currentColor"
          fontSize="14"
        >
          {value}
        </text>
      ))}

      <text
        x={cx}
        y={cy + bottomY}
        dy={8}
        textAnchor="middle"
        fill="currentColor"
        fontSize="14"
      >
        {payload.percentage.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })}
        %
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius + 10}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
        stroke="#fff"
        strokeWidth="3"
      />
    </g>
  );
};
